import {CheckCircleOutlined, ExperimentOutlined, SettingOutlined, InboxOutlined} from '@ant-design/icons';

export const versionStatusTag = (status) => {
    const availableStatus = {
        'STABLE': {
            color: 'blue',
            icon: <CheckCircleOutlined/>,
        },
        'BETA': {
            color: 'orange',
            icon: <ExperimentOutlined/>,
        },
        'DEVELOPMENT': {
            color: 'purple',
            icon: <SettingOutlined/>,
        },
        'ARCHIVED': {
            color: 'red',
            icon: <InboxOutlined/>,
        },
    };

    return availableStatus[status];
};
